import React  from 'react';
import classNames from 'classnames';

import { useAppDispatch, useAppSelector } from 'src/app/hooks';
import {
  toggleCreditsOpen,
  selectCreditsOpen,
} from 'src/state';
import styles from './Buttons.module.css';
import creditsButtonStyles from './CreditsButton.module.css';

interface Props {}

export function CreditsButton(props: Props) {
  const dispatch = useAppDispatch();
  const creditsAreOpen = useAppSelector(selectCreditsOpen);

  const onClick = () => {
    dispatch(toggleCreditsOpen());
  }

  const classes = classNames(
    styles['button'],
    creditsButtonStyles['credits-button'],
    {
      [styles['button--filled']]: creditsAreOpen,
    },
  );

  return <div className={classes} onClick={onClick} />;
}
